<template lang="pug">
  .review
    div
      h2 基础信息入库
        el-steps(
          :space="50"
          :active="step"
          finish-status="success"
          simple)
          el-step(title="检验")
          el-step(title="入库")
          el-step(title="完成")
      
      .form-box(:inline="true" v-if="detail && step === 1")
        el-form
          .row
            .group
              el-form-item(label="类别")
                el-input(size="small" :disabled="true" v-model="detail.CATEGORYNAME")
              el-form-item
                p(:class="reviewStatus.new_category ? 'hilight' : ''") {{ reviewStatus.new_category | boolMapper}}
              el-form-item
              el-button(v-if="!categoryConfirmed" type="primary" size="small" @click="handleComfirmed('category')") 确认
              el-button(v-else type="primary" size="small" @click="handleCancel('category')") 取消确认
            .group(:class="categoryConfirmed ? 'hi' : ''")
              el-form-item
                el-autocomplete(
                  class="inline-input"
                  size="small"
                  value="names"
                  v-model="categorySelectedText"
                  :fetch-suggestions="querySearchCategories"
                  placeholder="查找现有类别"
                  :trigger-on-focus="false"
                  :debounce="500"
                  @select="handleSelectCategory")
              el-form-item
                el-button(type="primary" size="small" @click="handleReplace('category')") 替换
            .group(:class="categoryConfirmed ? 'hi' : ''")
              el-form-item
                el-input(size="small" placeholder="修改类别" v-model="categoryModifyText")
              el-form-item
                el-button(type="primary" size="small" @click="handleModify('category')") 修改
          .row
            .group
              el-form-item(label="厂商简称")
                el-input(size="small" :disabled="true" v-model="detail.FACTORYNAME")
              el-form-item
                p(:class="reviewStatus.new_company_alias ? 'hilight' : ''") {{ reviewStatus.new_company_alias | boolMapper }}
              el-form-item
              el-button(v-if="!aliasConfirmed" type="primary" size="small" @click="handleComfirmed('company_alias')") 确认
              el-button(v-else type="primary" size="small" @click="handleCancel('company_alias')") 取消确认
            .group(:class="aliasConfirmed ? 'hi' : ''")
              el-form-item
                el-autocomplete(
                  class="inline-input"
                  size="small"
                  value="label"
                  value-key="label"
                  v-model="aliasSelectedText"
                  :fetch-suggestions="querySearchAlias"
                  placeholder="查找现有公司简称"
                  :trigger-on-focus="false"
                  :debounce="500"
                  @select="handleSelectAlias")
              el-form-item
                el-button(type="primary" size="small" @click="handleReplace('company_alias')") 替换
            .group(:class="aliasConfirmed ? 'hi' : ''")
              el-form-item
                el-input(size="small" placeholder="修改厂商简称" v-model="aliasModifyText")
              el-form-item
                el-button(type="primary" size="small" @click="handleModify('company_alias')") 修改
          
          .row
            .group
              el-form-item(label="产品")
                el-input(size="small" :disabled="true" v-model="detail.PRODUCTNAME")
              el-form-item
                p(:class="reviewStatus.new_product ? 'hilight' : ''") {{ reviewStatus.new_product | boolMapper }}
              el-form-item
              el-button(v-if="!productConfirmed" type="primary" size="small" @click="handleComfirmed('product')") 确认
              el-button(v-else type="primary" size="small" @click="handleCancel('product')") 取消确认
            .group(:class="productConfirmed ? 'hi' : ''")
              el-form-item
                el-autocomplete(
                  class="inline-input"
                  size="small"
                  value="label"
                  value-key="label"
                  v-model="productSelectedText"
                  :fetch-suggestions="querySearchProduct"
                  placeholder="查找现有产品"
                  :debounce="500"
                  @select="handleSelectProduct")
              el-form-item
                el-button(type="primary" size="small" @click="handleReplace('product')") 替换
            .group(:class="productConfirmed ? 'hi' : ''")
              el-form-item
                el-input(size="small" placeholder="修改产品名称" v-model="productModifyText")
              el-form-item
                el-button(type="primary" size="small" @click="handleModify('product')") 修改
        .el-form-item.bottom-ctrl
          el-button(type="primary" @click="fillAndCheck") 检验
          el-button(@click="handleClose") 取消
      
      .form-box(v-if="step === 2")
        el-form(:inline="true" style="width: 50%;margin: 0 auto;")
          .row
            .group
              el-form-item(label="类别")
                el-input(size="small" :disabled="true" v-model="detail.CATEGORYNAME")
              el-form-item
                p {{ reviewStatus.new_category | boolMapper}}
          .row
            .group
              el-form-item(label="产品")
                el-input(size="small" :disabled="true" v-model="detail.PRODUCTNAME")
              el-form-item
                p {{ reviewStatus.new_product | boolMapper}}
          .row
            .group
              el-form-item(label="厂商简称")
                el-input(size="small" :disabled="true" v-model="detail.FACTORYNAME")
              el-form-item
                p {{ reviewStatus.new_company_alias | boolMapper }}
          .box(v-if="reviewStatus.check_status === 'additional_info_required'")
            el-alert(title="没有找到厂商全称，请补充" type="warning" center)
            .group
              el-form-item(label="厂商全称")
                el-autocomplete(
                  class="inline-input"
                  size="small"
                  value="label"
                  value-key="label"
                  v-model="companyFullName"
                  :fetch-suggestions="querySearchCompanyFullName"
                  placeholder="查找或输入"
                  :trigger-on-focus="false"
                  :debounce="500"
                  @select="handleSelectCompanyFullName")
          .box(v-if="reviewStatus.check_status === 'conflict'")
            el-alert(
              title="厂商全称冲突！"
              type="error"
              :description="`产品与厂商简称关联的厂商全称冲突，将忽略该厂商简称。\n 产品关联的厂商全称：${reviewStatus.company_full_name_with_product} \n 厂商简称关联的厂商全称：${reviewStatus.company_full_name_with_alias}` "
              show-icon)
        .el-form-item.bottom-ctrl
            el-button(type="primary" @click="handleOneClick") 入库
            el-button(@click="handleBack") 上一步
      
      .form-box(v-if="step === 3")
        .note
          i.el-icon-success
          p 基本信息已入库
        .log
          p(v-for="(note, index) in logs") {{ index + 1 }} - {{ note }}
        .el-form-item.bottom-ctrl
          el-button(@click="handleClose") 关闭

</template>
<script>
import axios from 'axios'

export default {
  name: 'ReviewItem',
  props: ['reviewId', 'reviewStatus'],
  data () {
    return {
      step: 1,
      detail: null,
      categorySelectedText: null,
      categorySelectedId: null,
      categoryModifyText: null,
      categoryConfirmed: false,
      aliasSelectedText: null,
      aliasSelectedId: null,
      aliasModifyText: null,
      aliasConfirmed: false,
      productSelectedText: null,
      productSelectedId: null,
      productModifyText: null,
      productConfirmed: false,
      companyFullName: null,
      companyFullNameId: null,
      logs: []
    }
  },
  filters: {
    boolMapper (val) {
      if (val) {
        return '新增'
      } else {
        return '现有'
      }
    }
  },
  methods: {
    fetchData () {
      let url = `${this.$config.API.reviews.detail}/${this.reviewId}`
      axios.get(url)
        .then(res => {
          if (res.status === 200) {
            this.detail = res.data.transmitObj
          }
        })
    },
    querySearchCategories (keywords, cb) {
      if (!keywords) return
      let url = this.$config.API.autoComplete.category
      let data = {
        keywords: keywords
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    querySearchAlias (keywords, cb) {
      if (!keywords) return
      let url = this.$config.API.autoComplete.companyAlias
      let data = {
        keywords: keywords
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    querySearchProduct (keywords, cb) {
      // if (!keywords) return
      let data = {}
      if (!keywords) {
        console.log(this.detail)
        let categoryId = this.categorySelectedId || this.detail.CATEGORY_ID
        let factoryId = this.aliasSelectedId || this.detail.FACTORY_ID

        console.log(factoryId)

        if (categoryId) {
          data.category_id = categoryId
        }
        if (factoryId) {
          data.factory_id = factoryId
        }
      }
      data.keywords = keywords
      let url = this.$config.API.autoComplete.product
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    querySearchCompanyFullName (keywords, cb) {
      if (!keywords) return
      let url = this.$config.API.autoComplete.companyFullName
      let data = {
        keywords: keywords
      }
      axios.get(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    handleSelectCategory (selected) {
      this.categorySelectedId = selected.CID
    },
    handleSelectAlias (selected) {
      this.aliasSelectedId = selected.value
    },
    handleSelectProduct (selected) {
      this.productSelectedId = selected.value
    },
    handleSelectCompanyFullName (selected) {
      this.companyFullNameId = selected.QCID
    },
    handleComfirmed (type) {
      switch (type) {
        case 'category':
          this.categoryConfirmed = true
          break
        case 'company_alias':
          this.aliasConfirmed = true
          break
        case 'product':
          this.productConfirmed = true
          break
      }
    },
    handleCancel (type) {
      switch (type) {
        case 'category':
          this.categoryConfirmed = false
          break
        case 'company_alias':
          this.aliasConfirmed = false
          break
        case 'product':
          this.productConfirmed = false
          break
      }
    },
    handleReplace (type) {
      let url = this.$config.API.reviews.replace
      let data = {}
      let target = {}
      data.review_id = this.reviewId
      let status = Object.assign({}, this.reviewStatus)
      switch (type) {
        case 'category':
          data.entity = type
          target.id = this.categorySelectedId
          target.name = encodeURIComponent(this.categorySelectedText)
          data.data = target
          break
        case 'company_alias':
          data.entity = type
          target.id = this.aliasSelectedId
          target.name = encodeURIComponent(this.aliasSelectedText)
          data.data = target
          break
        case 'product':
          data.entity = type
          target.id = this.productSelectedId
          target.name = encodeURIComponent(this.productSelectedText)
          data.data = target
          break
      }
      axios.post(url, data)
        .then(res => {
          if (res.status === 200) {
            switch (type) {
              case 'category':
                this.detail.CATEGORYNAME = this.categorySelectedText
                this.categorySelectedId = null
                this.categorySelectedText = null
                this.categoryConfirmed = true
                status.new_category = false
                break
              case 'company_alias':
                this.detail.FACTORYNAME = this.aliasSelectedText
                this.aliasSelectedId = null
                this.aliasSelectedText = null
                this.aliasConfirmed = true
                status.new_company_alias = false
                break
              case 'product':
                this.detail.PRODUCTNAME = this.productSelectedText
                this.productSelectedId = null
                this.productSelectedText = null
                this.productConfirmed = true
                status.new_product = false
                break
            }
            this.$emit('statusUpdate', status)
          }
        })
        .catch(err => {
          console.log(err)
          this.$message.error('替换失败，请稍后重试')
        })
    },
    handleModify (type) {
      let url = this.$config.API.reviews.modify
      let data = {}
      switch (type) {
        case 'category':
          data.entity = type
          data.review_id = this.reviewId
          data.name = encodeURIComponent(this.categoryModifyText)
          break
        case 'company_alias':
          data.entity = type
          data.review_id = this.reviewId
          data.name = encodeURIComponent(this.aliasModifyText)
          break
        case 'product':
          data.entity = type
          data.review_id = this.reviewId
          data.name = encodeURIComponent(this.productModifyText)
          break
      }
      axios.post(url, data)
        .then(res => {
          if (res.status === 200) {
            switch (type) {
              case 'category':
                this.detail.CATEGORYNAME = this.categoryModifyText
                this.categorySelectedId = null
                this.categorySelectedText = null
                this.categoryModifyText = null
                this.categoryConfirmed = true
                break
              case 'company_alias':
                this.detail.FACTORYNAME = this.aliasModifyText
                this.aliasSelectedId = null
                this.aliasSelectedText = null
                this.aliasModifyText = null
                this.aliasConfirmed = true
                break
              case 'product':
                this.detail.PRODUCTNAME = this.productModifyText
                this.productSelectedId = null
                this.productSelectedText = null
                this.productModifyText = null
                this.productConfirmed = true
                break
            }
          }
        })
        .catch(err => {
          console.log(err)
          this.$message.error('替换失败，请稍后重试')
        })
    },
    fillAndCheck () {
      let url = this.$config.API.reviews.fillAndCheck
      return new Promise((resolve, reject) => {
        axios.post(url, {
          review_id: this.reviewId
        }).then(res => {
          switch (res.status) {
            case 200: // 进入入库页
              this.step = 2
              this.$emit('statusUpdate', res.data.data)
              break
            case 204: // 检查通过，进入成功提示页面
              // this.currentReviewId = null
              this.$emit('finished', this.reviewId)
              this.step = 3
              break
          }
          resolve(res)
        }).catch(err => {
          switch (err.response.status) {
            case 400:
              this.$message.error('未找到该条点评信息')
              break
            case 500:
              this.$message.error('操作失败')
          }
        })
      })
    },
    handleBack () {
      this.step = 1
    },
    handleClose (e) {
      console.log(e)
      this.$parent.handleClose()
    },
    handleOneClick () {
      this.fillAndCheck()
        .then(res => {
          if (res.status === 200) {
            this.storeProcess()
          }
        })
    },
    storeProcess () {
      let url = this.$config.API.reviews.createEntityByOneClick
      let data = {}
      data.review_id = this.reviewId
      if (this.reviewStatus.check_status === 'additional_info_required') {
        data.factory_full_name = encodeURIComponent(this.companyFullName)
        data.factory_full_name_id = this.companyFullNameId || ''
      } else if (this.reviewStatus.check_status === 'conflict') {
        data.factory_full_name = this.reviewStatus.company_full_name_with_product
        data.factory_full_name_id = this.reviewStatus.company_full_name_id_with_product
        data.factory_full_name = encodeURIComponent(data.factory_full_name)
      } else {
        data.factory_full_name = this.reviewStatus.company_full_name_with_product || this.reviewStatus.company_full_name_with_alias
        data.factory_full_name_id = this.reviewStatus.company_full_name_id_with_product || this.reviewStatus.company_full_name_id_with_alias
        data.factory_full_name = encodeURIComponent(data.factory_full_name)
      }
      axios.post(url, data)
        .then(res => {
          if (res.data.result === 'success') {
            this.logs = res.data.logs
            this.step = 3
            this.$emit('finished', this.reviewId)
          }
        })
    }
  },
  mounted () {
    this.fetchData()
    console.log(this.reviewStatus)
  }
}
</script>

<style lang="sass" scoped>
  .el-steps
    width: 50%
    margin: 20px auto
</style>



// WEBPACK FOOTER //
// Detail.vue?e469fb80